import React from "react";
import { FormControl, FormControlLabel, Radio, RadioGroup } from "@mui/material";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { getMerchantConfig, getRmsConfig } from "features/config/configSlice";
import { StyledPickup } from "./styled";

export const PickupAddress = ({
  setAddressChange,
  edit,
  updatedAddress,
  disabled,
  serviceable,
  shipmentMethod,
  setShipmentMethod,
}) => {
  const { t } = useTranslation();
  const merchantConfig = useSelector(getMerchantConfig);
  const rmsConfig = useSelector(getRmsConfig);
  const location = useLocation();
  const isReturnCart = location.pathname.endsWith("/return-cart");
  const streetAddress = [
    updatedAddress?.addressLine1,
    updatedAddress?.addressLine2,
  ]
    .filter(Boolean)
    .join(", ");
  const cityAddress = [
    updatedAddress?.city && updatedAddress?.pincode
      ? `${updatedAddress.city} - ${updatedAddress.pincode}`
      : updatedAddress?.city || updatedAddress?.pincode,
    updatedAddress?.state,
  ]
    .filter(Boolean)
    .join(", ");

  return (
    <StyledPickup $primaryColor={merchantConfig.primary_theme_color}>
      <div className="pickup-address-row">
        <LocationOnOutlinedIcon className="pickup-address-icon" />
        <p className="pickup-address">
          {streetAddress ? (
            <span className="pickup-address-line">{streetAddress}</span>
          ) : null}
          {cityAddress ? (
            <span className="pickup-address-line">{cityAddress}</span>
          ) : null}
        </p>
      </div>

      {((!rmsConfig.supports_return_pickup && rmsConfig.self_ship) ||
        !serviceable) && (
        <div className="ship-back-panel">
          <p className="ship-back">
            {!serviceable &&
              !rmsConfig.show_shipping_preference &&
              t("address.notServiceable")}{" "}
            {t("address.shipBackTo")}
          </p>
          <p className="delivery-address">
            {rmsConfig.return_address?.name},{" "}
            {rmsConfig.return_address?.address_line_1},{" "}
            {rmsConfig.return_address?.address_line_2}{" "}
            {rmsConfig.return_address?.address_line_2 && ","}{" "}
            {rmsConfig.return_address?.city}, {rmsConfig.return_address?.state},{" "}
            {rmsConfig.return_address?.country}, -{" "}
            {rmsConfig.return_address?.pin}
          </p>
        </div>
      )}

      {rmsConfig.show_shipping_preference && isReturnCart && (
        <div className="customer-preference">
          <FormControl className="form-control-preference">
            <span className="title">Pickup Type:</span>
            <RadioGroup
              row
              aria-labelledby="shipping-option-type-buttons"
              name="shipping-option-type-buttons"
              value={shipmentMethod || ""}
              onChange={(event) => setShipmentMethod(event.target.value)}
            >
              {rmsConfig.supports_return_pickup && (
                <FormControlLabel
                  id="1"
                  value="merchant_handles_return_shipment"
                  control={<Radio size="small" />}
                  label="Door Step Pickup"
                />
              )}
              {!rmsConfig.supports_return_pickup && rmsConfig.self_ship && (
                <FormControlLabel
                  id="2"
                  value="customer_ships_back"
                  control={<Radio size="small" />}
                  label="Self Ship"
                />
              )}
            </RadioGroup>
          </FormControl>
        </div>
      )}
    </StyledPickup>
  );
};
